import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { PopoverController } from '@ionic/angular/standalone';
import { PopoverOption } from '@utils/controls.utils';

@Component({
  imports: [
    CommonModule,
  ],
  selector: 'app-popover-options',
  styleUrl: './popover-options.component.scss',
  templateUrl: './popover-options.component.html',
})
export class PopoverOptionsComponent<T> {
  @Input() data!: T;
  @Input() options!: PopoverOption<T>[][];

  constructor(
    private popoverController: PopoverController,
  ) {}

  protected selectOption(option: PopoverOption<T>): void {
    option.onClick(this.data);
    this.popoverController.dismiss();
  }
}
